export default {
  "gen_btn_avanti": "NEXT",
  "gen_compagnia_aerea": "Airline Company",
  "gen_numero_volo": "Flight number",
  "gen_partenza": "Departure",
  "gen_destinazione": "Destination",
  "gen_data_volo": "Flight date",
  "gen_data_volo_label": "Specify flight date",
  "aerop_nessun_risultato":"No results found for ",
  "header_title": "GET YOUR MONEY BACK",
  "header_body": "<h1 class=\"headText\"><span class=\"bigSize\">S</span>COPRI SUBITO SE HAI DIRITTO A FINO <span class=\"colorBlue bigSize\">600€</span> DI RIMBORSO!</h1><div class=\"subText\"> • Invia una richiesta per ogni codice di prenotazione • <br>• Se il viaggiatore è un minore, è necessario che la richiesta sia inoltrata da uno dei genitori•</div>",
  "st1_scegliere_compagnia": "Select an airline company",
  "st1_numero_volo_required": "Please specify flight number",
  "st1_numero_volo_invalid": "Incorrect flight number",
  "st1_cerca_aeroporto": "Enter city or airport name",
  "st1_data_volo_required": "Insert day in the format dd/mm/yyyy",
  "st1_data_volo_eccedente": "It is possible to insert only flights on a date that has already passed or scheduled for the next 14 days",
  "st1_tipologia_problema": "Select the type of problem",
  "st1_tipologia_problema_label": "Problem encountered",
  "st1_tipologia_problema_required": "Select the kind of problem encoutered",
  "st1_domanda_coincidenze": "Did your flight have connections?",
  "st1_coincidenze_opt1": "Yes",
  "st1_coincidenze_opt2": "No",
  "st1_compagnia_aerea": "Airline Company",
  "st1_partenza": "⮭ Search departure",
  "st1_partenza_label": "Departure",
  "st1_destinazione": "⮯ Search destination",
  "st1_destinazione_label": "Destination",
  "st2_problematica_ritardo" : "DELAY OF MORE THAN 3 HOURS",
  "st2_problematica_cancellazione" : "FLIGHT CANCELLATION",
  "st2_problematica_bagaglio" : "LOSS OR DELAYED LUGGAGE",
  "st2_problematica_overbooking" : "OVERBOOKING",
  "err_attenzione": "Warning!",
  "err_terminiscaduti": "Deadline expired",
  "err_terminiscaduti_msg": "We are sorry, but we cannot accept the case as the two year deadline for requesting a refund has passed.",
  "err_errore_sistema": "We are sorry to inform you that an unexpected error occurred during the operation. Please try again in a few minutes.",
  "err_datalimitata":"For the selected company it is possible to enter only flights from 15 October 2021 onwards",
  "last_instestazione" : "We've received your request!",
  "last_corpo" : "Thanks for trusting us. You will shortly receive a communication regarding your request",
  "last_button" : "Insert a new request",
  "numvolo_hint" : "<p>Selezionando la compagnia aerea la parte iniziale viene compilata automaticamente, non resta che inserire la parte numerica composta da quattro cifre.<br><b>Se il tuo numero di volo è composto da 3 soli numeri, inserisci uno zero iniziale: se il tuo volo è FR123 dovrai scrivere FR<span style='color:#bb271b'>0</span>123.</b><br>Numeri di volo validi sono : EJU2865, VY6375, FR4001, FR0123, LH0034...</p>",
  "problematica1" : "DELAY OF MORE THAN 3 HOUR",
  "problematica2" : "FLIGHT CANCELLATION",
  "problematica3" : "LOST OR DELAYED LUGGAGE",
  "problematica4" : "OVERBOOKING",
  "st4_nome" : "Enter your name",
  "st4_nome_label" : "Name",
  "st4_cognome" : "Enter your last name",
  "st4_cognome_label" : "Last name",
  "st4_email" : "Enter a valid email address",
  "st4_email_label" : "Email",
  "st4_telefono" : "Phone",
  "st4_compagnia" : "Airline Company",
  "st4_nvolo" : "Flight Number",
  "st4_partenza" : "Departure",
  "st4_destinazione" : "Destination",
  "st4_tipoproblema" : "Problem encoutered",
  "st4_istruzioni" : "Explain the problem you had in a few words",
  "st4_istruzioni_placeholder" : "Write here ... (Ex.: on 01/01/2021 I received an email from the travel agency, indicating the cancellation of the flight.. etc...).",
  "st4_datavolo" : "Flight date",
  "st4_modificaidati" : "Edit",
  "gen_possieuncodicepriorita":"Do you have a priority code?",
  "gen_possieuncodicepriorita_placeholder":"Priority code",
  "st3_telefono_required":"Enter a telephone number",
  "st1_partenza_required": "Please indicate the departure airport",
  "st1_destinazione_required": "Please indicate the destination airport",
  "st3_nome_required": "Please enter your name",
  "st3_cognome_required": "Please enter your surname",
  "st3_email_required": "Enter your email address",
  "st3_email_invalid": "Email address is not valid",
  "st3_phone_required": "Enter a telephone number",
  "st3_codicepartner_required": "Enter a valid priority code or omit this information",
  "gen_conferma": "Submit",
  "st5_vuoi_completare": "Do you want to sensibly reduce the processing time of your application for free?",
  "st5_vai": "Go!",
  "st6_dimunzionetempi": "Sped up the processing time by 25%",
  "st6_codicefiscale": "Enter fiscal code",
  "st6_codicefiscale_label": "Passenger's fiscal code",
  "st6_nome_required": "Enter the passenger's name",
  "st6_cognome_required": "Enter the passenger's surname",
  "st6_codicefiscale_required": "Enter the tax code or indicate the passenger as a non-Italian citizen",
  "st6_codicefiscale_length": "Fiscal code is not valid",
  "st6_codicefiscale_invalid": "Fiscal code is not valid",
  "st6_codicefiscale_minore": "An adult passenger must first be entered",
  "st6_firma_required": "It is necessary to enter a signature",
  "st6_cancellafirma": "Clear signature",
  "st6_bottoneavanti": "Speed up by 40%",
  "gen_data_nonvalida": "Not a valid date",
  "st7_bottoneavanti": "Speed up by 50%",
  "st7_inseriscidata": "Enter a date",
  "st8_riprotezione": "Airline rerouting or refund ?",
  "gen_si": "Yes",
  "gen_no": "No",
  "st7_diminuzionetempi": "Sped up the processing time by ",
  "st8_diminuzionetempi": "Sped up the processing time by ",
  "gen_datanonvalida" : "Not a valid date",
  "st8_datariprotezione_required" : "Specify reimbursement date",
  "st8_datariconsegna_required" : "Bagagge drop off date",
  "st8_inviatutto" : "Submit",
  "tk1_heading_1": "OK, YOU SPED UP YOUR APPLICATION PROCESSING TIMES!",
  "tk1_text_1" : "Your ticket has the following identifier :",
  "tk1_text_2" : "Would you like to add more passengers to this refund request?",
  "tk1_button_nuovo_passeggero" : "Add passenger",
  "tk1_button_concludi" : "Complete request",
  "ticket_esistente_heading1": "Existing ticket",
  "ticket_esistente_text": "There is already a ticket associated with your email address for this flight.You'll receive an email with the instructions regarding your request",
  "pass_seleziona_tutor":"Select a tutor for this passenger",
  "st1_numero_volo_nonvalido":"Invalid flight number",
  "st2_domanda_coincidenze":"Did your flight have connections ?",
  "fup_caricafile":"File upload",
  "fup_dimensione":"File size",
  "fup_warningdimensione":"Warning! This file exceeds the maximum size allowed.",
  "fup_conferma":"Continue",
  "fup_annulla":"Cancel",
  "fup_riprova":"Retry",
  "fup_uploaderror":"A problem occurred with the file upload. Continue without uploading the file or retry later",
  "error_generic_titolo":"Unexpected error!!",
  "error_generic_text":"An unexpected error occurred while trying to communicate with the server.Please try again in a few minutes.",
  "st6_dichiarazione_non_italiano": "Dichiaro di non essere cittadino italiano e di non possedere un codice fiscale valido.",
  "dimensione_max_10mb" : "Maximum 10MB",
  "documento_identita" : "Passenger ID",
  "carta_imbarco" : "Boarding pass",
  "PIR" : "PIR ( Property irregularity Report)",
  "giorno_in_cui_ha_ricevuto_comunicazione" : "Day you received notice of variation ( cancellation or delay ) if any",
  "acquisti_successivi": "Acquisti successivi alla variazione del volo",
  "scontrini_ricevute":"Scontrini/Ricevute",
  "st4_telefono_label":"Phone number"
}
